import type { ZodObject, ZodRawShape } from 'zod';

export function objectKeys<T extends object>(obj: T): Array<keyof T> {
    return Object.keys(obj) as Array<keyof T>;
}

export function getTopLevelKeys<T extends ZodRawShape>(schema: ZodObject<T>): string[] {
    return Object.keys(schema.shape);
}
